import { c as _c } from "react/compiler-runtime";
import { Card, Text, VStack } from '@chakra-ui/react';
import { CoherenceItemView } from '@src/components/sco/PitchDeckAuditor/model/types';

/** Cross-slide coherence dimensions from `crossSlideCoherenceAsJson`. */
export function CoherencePanel(t0) {
  const $ = _c(4);
  const {
    coherence
  } = t0;
  if (!coherence.length) {
    return null;
  }
  let t1;
  if ($[0] !== coherence) {
    t1 = coherence.map(_temp);
    $[0] = coherence;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <VStack align="stretch" gap={2}>{t1}</VStack>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  return <Card.Root key={item.key} size="sm" variant="subtle"><Card.Body py={3}><Text fontSize="sm" fontWeight="semibold">{item.label}</Text><Text color="fg.muted" fontSize="sm" mt={0.5}>{item.body}</Text></Card.Body></Card.Root>;
}